var render = function render(){var _vm=this,_c=_vm._self._c;return _c('login',{attrs:{"loading-app":_vm.loadingApp,"product-type":"Adopt","is-white-label":_vm.isWhiteLabel},on:{"on-user-authenticated":_vm.postLogin},scopedSlots:_vm._u([{key:"logo",fn:function(){return [_vm._t("logo")]},proxy:true},{key:"nightLogo",fn:function(){return [_vm._t("nightLogo")]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }